import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#003b46',
                secondary: '#07575b',
                accent: '#ff9800',
                info: '#66a5ad',
                lightGreenGrey: '#8da6ad',
                error: '#F4511E',
                lightSeaGreen: '#20b2aa',
                indianRed: '#cd5c5c',
            },
            dark: {
                primary: '#003b46',
                secondary: '#07575b',
                accent: '#ff9800',
                info: '#66a5ad',
                error: '#F4511E'
            }
        },
    }
});
